"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _userAnalyticsJs = _interopRequireDefault(require("@godaddy/user-analytics-js"));
var _getShopperId = _interopRequireDefault(require("./getShopperId"));
var _isProd = _interopRequireDefault(require("./isProd"));
var tracker = null;

// TODO remove this in the next major release
/**
 * Get the UserAnalytics tracker object
 * @param {string} rootDomain - the root domain of the site
 * @param {boolean} mock - if true, will re-instantiate the tracker object. Used for unit tests only
 * @returns {*} - the user-analytics-js tracker object
 * @deprecated - users of modal-loader should instantiate their own user-analytics-js object directly
 */
function getTracker(rootDomain) {
  var mock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // we want mocked calls to re-instantiate new object to compare against new properties
  if (tracker && !mock) return tracker;
  var prod = (0, _isProd.default)(rootDomain);
  var shopperId = (0, _getShopperId.default)() || '';
  var isTLA = shopperId.length === 3;
  tracker = (0, _userAnalyticsJs.default)({
    traffic2: {},
    fullstory: true,
    debug: prod && isTLA || !prod
  });
  return tracker;
}
var _default = exports.default = getTracker;